import { ChangeEvent, useRef } from "react";
import { toast } from "react-toastify";
import { downloadExcel } from "../../utils/DownloadFile";
import { getSpocTemplate } from "../../api/spoc";
import { useBulkUploadSpocDetails } from "../../queries/spocDetails";
import { PrimaryCTAButton, ButtonSize } from "../quickRound/CTAButtonComponents";

export default function SpocTemplateActions() {
  const excelInputRef = useRef<HTMLInputElement>(null);
  const { mutate: bulkUploadSpocDetails, isLoading: excelUploading } =
    useBulkUploadSpocDetails();

  const handleExcelUploadClick = () => {
    excelInputRef.current?.click();
  };

  const handleExcelUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    const validExtensions = ["xlsx", "xlsm"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (!fileExtension || !validExtensions.includes(fileExtension)) {
      toast.error("Please upload a valid Excel file (.xlsx or .xlsm)");
      return;
    }

    bulkUploadSpocDetails(file, {
      onSuccess: () => {
        toast.success("SPOC details uploaded and saved successfully!");
      },
      onError: (err: any) => {
        const msg =
          err?.response?.data?.errorMessage ||
          err?.response?.data?.message ||
          err?.response?.data?.reason ||
          "Failed to upload and save SPOC details.";
        toast.error(msg);
      },
    });
  };

  const handleDownloadTemplate = () => {
    getSpocTemplate()
      .then((base64) => {
        downloadExcel(base64, "SPoC_Details_Template");
      })
      .catch((err: any) => {
        toast.error(
          err?.response?.data?.errorMessage || "Failed to download template"
        );
      });
  };

  return (
    <div className="flex flex-col items-start gap-1 pt-2.5">
      <input
        ref={excelInputRef}
        type="file"
        accept=".xlsx,.xlsm"
        onChange={handleExcelUpload}
        className="hidden"
      />
      <PrimaryCTAButton
        className="min-w-[160px] flex justify-center text-center"
        event-name="Upload Excel for SPOC Details"
        buttonSize={ButtonSize.MEDIUM}
        onClick={handleExcelUploadClick}
        disabled={excelUploading}
      >
        {excelUploading ? "Uploading..." : "Upload Spoc/Kmp Details "}
      </PrimaryCTAButton>

      <p className="text-xs text-gray-400 whitespace-nowrap">
        Download the template{" "}
        <span
          onClick={handleDownloadTemplate}
          className="cursor-pointer font-medium text-blue-600 underline hover:text-blue-800"
        >
          here
        </span>
      </p>
    </div>
  );
}
